export default "__VITE_ASSET__0e5d01eb__"